import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { settingsReducer, userReducer } from 'stores';
import { concatReducers } from 'react-structure-admin';
import authReducer from './auth/authReducer';
import accountReducer from './accounts/accountReducer';
import medicalRecordSectionReducer from './medicalRecordSections/medicalRecordSectionReducer';
import eventReducer from './events/eventReducer';
import attendanceReducer from './attendances/attendanceReducer';
import patientReducer from './patients/patientReducer';
import treatmentReducer from './treatments/treatmentReducer';
import dashboardReducer from './dashboards/dashboardReducer';
import companyReducer from './companies/companyReducer';
import subscriptionReducer from './subscriptions/subscriptionReducer';
import prescriptionReducer from './prescriptions/prescriptionReducer';
import financialEntryReducer from './financialEntries/financialEntryReducer';
import categoryReducer from './categories/categoryReducer';
import checkingAccountReducer from './checkingAccounts/checkingAccountReducer';
import campaignReducer from './campaigns/campaignReducer';
import ledgerAccountReducer from './ledgerAccounts/ledgerAccountReducer';
import standardHistoryReducer from './standardHistories/standardHistoryReducer';
import openFinancialExchangeReducer from './openFinancialExchanges/openFinancialExchangeReducer';
import financialStatisticReducer from './financialStatistic/financialStatisticReducer';
import collaboratorReducer from './collaborators/collaboratorReducer';
import healthServiceProviderReducer from './healthServiceProviders/healthServiceProviderReducer';
import packageReducer from './packages/packageReducer';
import partnershipReducer from './partnerships/partnershipReducer';
import { LOGIN_REQUEST } from './auth/authActions';
import resourceReducer from './resourceReducer';
import productMovementReducer from './productMovements/productMovementReducer';
import patientPackageReducer from './patients/patientPackageReducer';
const resourceRedurcers = concatReducers(
  [
    resourceReducer,
    userReducer,
    accountReducer,
    eventReducer,
    medicalRecordSectionReducer,
    attendanceReducer,
    patientReducer,
    treatmentReducer,
    dashboardReducer,
    companyReducer,
    prescriptionReducer,
    financialEntryReducer,
    categoryReducer,
    checkingAccountReducer,
    campaignReducer,
    ledgerAccountReducer,
    standardHistoryReducer,
    openFinancialExchangeReducer,
    financialStatisticReducer,
    collaboratorReducer,
    healthServiceProviderReducer,
    packageReducer,
    partnershipReducer,
    productMovementReducer,
    patientPackageReducer
  ],
  []
);

const appReducer = (history) => {
  const reducerMap = {
    router: connectRouter(history),
    resources: resourceRedurcers,
    auth: authReducer,
    subscriptions: subscriptionReducer,
    settings: settingsReducer
  };

  return combineReducers(reducerMap);
};

const rootReducer = (history) => (state, action) => {
  try {
    if (action.type === LOGIN_REQUEST) {
      state.resources = {};
      return appReducer(history)(state, action);
    }

    return appReducer(history)(state, action);
  } catch (error) {
    return state;
  }
};

export default rootReducer;
